import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EC2Instance, InstanceMetrics } from '../../types/ec2';

interface EC2State {
  selectedInstance: EC2Instance | null;
  instances: EC2Instance[];
  metrics: Record<string, InstanceMetrics>;
  isLoading: boolean;
  error: string | null;
  filters: {
    search: string;
    state: string;
    vpc: string;
  };
}

const initialState: EC2State = {
  selectedInstance: null,
  instances: [],
  metrics: {},
  isLoading: false,
  error: null,
  filters: {
    search: '',
    state: 'all',
    vpc: 'all',
  },
};

const ec2Slice = createSlice({
  name: 'ec2',
  initialState,
  reducers: {
    setSelectedInstance: (state, action: PayloadAction<EC2Instance | null>) => {
      state.selectedInstance = action.payload;
    },
    setInstances: (state, action: PayloadAction<EC2Instance[]>) => {
      state.instances = action.payload;
    },
    updateInstanceMetrics: (state, action: PayloadAction<{ instanceId: string; metrics: InstanceMetrics }>) => {
      state.metrics[action.payload.instanceId] = action.payload.metrics;
    },
    setFilters: (state, action: PayloadAction<Partial<EC2State['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearEC2State: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setSelectedInstance,
  setInstances,
  updateInstanceMetrics,
  setFilters,
  setLoading,
  setError,
  clearEC2State,
} = ec2Slice.actions;

export default ec2Slice.reducer;